import {Corridor} from '../../corridor/corridor';
import {PricingItem} from './pricing-item';
import {Article} from './article';

export class DeviceConsumableWithSuppPricingItem extends PricingItem {

    constructor(public readonly device?: Article,
                public readonly consumable?: Article,
                public readonly consumableExtraPrice?: string,
                public readonly oldConsumableExtraPrice?: string,
                public readonly specificities?: Record<string, any>,
                public readonly effTheo? : number,
                public readonly franchise? : any,
                public readonly discount?: string,
                public readonly totalAppliedPriceColor?: string,
                public readonly additionalConsumablePrice?: string,
                public readonly deviceConsumableCorridor?: Corridor,
                public readonly deviceConsumableAppliedPrice?: string,
    ) {
        super();
    }
}
